import React from "react";
import { 
  Compass, 
  BarChart3, 
  FileText, 
  MessageSquare, 
  Clock, 
  Boxes,
  ArrowRight
} from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";

const ValueModulesSection = () => {
  const { currentLanguage } = useLanguage();

  const modules = [
    {
      icon: Compass,
      title: currentLanguage === 'de' ? 'KI-Kompass' : 'AI Compass',
      description: currentLanguage === 'de' 
        ? 'Strategische Ausrichtung und Priorisierung Ihrer KI-Initiativen'
        : 'Strategic alignment and prioritization of your AI initiatives',
      color: 'from-blue-500 to-cyan-500'
    },
    {
      icon: BarChart3,
      title: currentLanguage === 'de' ? 'Potenzial-Analyse' : 'Potential Analysis',
      description: currentLanguage === 'de'
        ? 'Quantifizierung der Werthebel in Ihren Geschäftsprozessen'
        : 'Quantification of value levers in your business processes',
      color: 'from-brand to-green-500'
    },
    {
      icon: FileText,
      title: currentLanguage === 'de' ? 'KI-Canvas' : 'AI Canvas',
      description: currentLanguage === 'de'
        ? 'Strukturierte Use-Case-Entwicklung mit klaren KPIs'
        : 'Structured use case development with clear KPIs',
      color: 'from-purple-500 to-pink-500'
    },
    {
      icon: MessageSquare,
      title: currentLanguage === 'de' ? 'Prompt Playbook' : 'Prompt Playbook',
      description: currentLanguage === 'de'
        ? 'Standardisierte Prompt-Patterns für konsistente Ergebnisse'
        : 'Standardized prompt patterns for consistent results',
      color: 'from-orange-500 to-red-500'
    },
    {
      icon: Clock,
      title: currentLanguage === 'de' ? 'Zeitfresser-Matrix' : 'Time Drain Matrix',
      description: currentLanguage === 'de'
        ? 'Identifikation der größten Automatisierungspotenziale'
        : 'Identification of the biggest automation potentials',
      color: 'from-yellow-500 to-orange-500'
    },
    {
      icon: Boxes,
      title: currentLanguage === 'de' ? 'Use Case Factory' : 'Use Case Factory',
      description: currentLanguage === 'de'
        ? 'Industrialisierte Umsetzung mit Templates und Gates'
        : 'Industrialized implementation with templates and gates',
      color: 'from-indigo-500 to-purple-500'
    }
  ];

  return (
    <section className="py-20 md:py-28 bg-surface">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="max-w-[64ch] mb-14">
          <span className="inline-block bg-brand/10 text-brand-300 border border-brand-400/25 px-3 py-1.5 rounded-full text-xs font-medium mb-5">
            {currentLanguage === 'de' ? 'Die 6 Module' : 'The 6 Modules'}
          </span>
          <h2 className="text-[clamp(1.9rem,3.6vw,3rem)] font-extrabold tracking-[-0.032em] leading-[1.06] [text-wrap:balance] text-ink mb-5">
            {currentLanguage === 'de' 
              ? 'Wir bringen Ordnung, Struktur und Wirkung'
              : 'We bring order, structure and impact'
            }
          </h2>
          <p className="text-[1.05rem] leading-relaxed text-ink-muted max-w-[62ch]">
            {currentLanguage === 'de'
              ? 'Unsere bewährte Methodik transformiert KI-Chaos in steuerbare Wertschöpfung – Schritt für Schritt, im Tempo Ihrer Organisation.'
              : 'Our proven methodology transforms AI chaos into controllable value creation – step by step, at the pace of your organization.'
            }
          </p>
        </div>

        {/* Sechs Module als Index-Zeilen: die Abfolge ist Teil der Methodik,
            deshalb Zeilen mit Haarlinien statt gleichfoermiger Karten. */}
        <ol className="border-t border-hairline">
          {modules.map((module, index) => (
            <li
              key={index}
              className="group grid gap-3 border-b border-hairline py-7 transition-[background-color,padding] duration-300 ease-brand hover:bg-brand/[0.045] hover:pl-4 md:grid-cols-[64px_300px_1fr] md:items-baseline md:gap-8"
            >
              <span className="text-sm font-bold tabular-nums text-brand-300">
                {String(index + 1).padStart(2, '0')}
              </span>
              <h3 className="text-xl font-bold tracking-[-0.02em] text-ink transition-colors group-hover:text-brand-300">
                {module.title}
              </h3>
              <p className="max-w-[62ch] text-[0.95rem] leading-relaxed text-ink-muted">
                {module.description}
              </p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default ValueModulesSection;
